<div class="container p-5 h-100">
    <app-call-log-list *ngIf="callLogResponses && !shouldRenderCallViewComponent" [callLogResponses]="callLogResponses"></app-call-log-list>
    <app-call-log-view *ngIf="shouldRenderCallViewComponent" [callLog]="currentCallLog!"></app-call-log-view>
</div>